/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClockOutAttestationRequest,
  GigsterTimesheet,
  PatchedGigsterTimesheetRequest,
  PatchedShiftBreakWriteRequest,
  PatchedTimePunchPartialUpdateRequest,
  PayStatusCheckRequestRequest,
  PayStatusCheckResponse,
  ShiftBreakBase,
  ShiftBreakClaimHistoryRevision,
  ShiftBreakClaimOverrideRequest,
  ShiftBreakClaimRead,
  ShiftBreakClaimWriteRequest,
  ShiftBreakComplianceCheckRequestRequest,
  ShiftBreakComplianceCheckResponse,
  ShiftBreakHistoryRevision,
  ShiftBreakWrite,
  ShiftBreakWriteRequest,
  SuggestedBreak,
  TimePunchCreate,
  TimePunchCreateRequest,
  TimePunchPartialUpdate,
  TimePunchRetrieve,
  TimePunchVerifyRequestRequest,
  TimesheetsShiftBreaksCreateParams,
  TimesheetsShiftBreaksHistoryListParams,
  TimesheetsShiftBreaksListParams,
  TimesheetsShiftBreaksPartialUpdateParams,
  TimesheetsSuggestedBreaksListParams,
  _TimesheetTimePunchInline
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTimesheetsRetrieveUrl = (id: string,) => {




  return `/api/timesheets/${id}/`
}

/**
 * A timesheet is a collection of time-punches for a given gig application.
 * This API is designed for gigpro admins to allow read and update of timesheets,
 * and to allow pros to read them.
 */
export const timesheetsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<GigsterTimesheet> => {

  return customFetch<GigsterTimesheet>(getTimesheetsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimesheetsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/timesheets/${id}/`
    ] as const;
    }


export const getTimesheetsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof timesheetsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimesheetsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timesheetsRetrieve>>> = ({ signal }) => timesheetsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimesheetsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof timesheetsRetrieve>>>
export type TimesheetsRetrieveQueryError = void


export function useTimesheetsRetrieve<TData = Awaited<ReturnType<typeof timesheetsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof timesheetsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsRetrieve<TData = Awaited<ReturnType<typeof timesheetsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof timesheetsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsRetrieve<TData = Awaited<ReturnType<typeof timesheetsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimesheetsRetrieve<TData = Awaited<ReturnType<typeof timesheetsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimesheetsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimesheetsPartialUpdateUrl = (id: string,) => {




  return `/api/timesheets/${id}/`
}

/**
 * A timesheet is a collection of time-punches for a given gig application.
 * This API is designed for gigpro admins to allow read and update of timesheets,
 * and to allow pros to read them.
 */
export const timesheetsPartialUpdate = async (id: string,
    patchedGigsterTimesheetRequest?: PatchedGigsterTimesheetRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigsterTimesheet> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigsterTimesheet>(getTimesheetsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedGigsterTimesheetRequest)
  }
);}





export const getTimesheetsPartialUpdateMutationKey = () => ['timesheetsPartialUpdate'] as const;

export const getTimesheetsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsPartialUpdate>>, TError,TimesheetsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsPartialUpdate>>, TError,TimesheetsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getTimesheetsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsPartialUpdate>>, TimesheetsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  timesheetsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsPartialUpdate>>>
    export type TimesheetsPartialUpdateMutationBody = PatchedGigsterTimesheetRequest | undefined
    export type TimesheetsPartialUpdateMutationError = void
    export type TimesheetsPartialUpdateMutationVariables = {id: string;data?: PatchedGigsterTimesheetRequest}

    export const useTimesheetsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsPartialUpdate>>, TError,TimesheetsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsPartialUpdate>>,
        TError,
        TimesheetsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getTimesheetsPayStatusCheckCreateUrl = (id: string,) => {




  return `/api/timesheets/${id}/pay-status-check/`
}

/**
 * Side-effect-free pay-status preview for proposed clock-in/out times.
 *
 * Evaluates the *proposed* times against the SAME ``GigApplication.pay_status()`` determination
 * the real submit + earnings surfaces use (no forked ladder, nothing persisted), so mobile can
 * render the matching pay-delay verbiage on the Review & attest screen before committing. The
 * real submit remains the authoritative backstop — this drives mobile UX only. A pro may only
 * evaluate their own application's timesheet (get_object() → 403/404 via the Unsafe permission).
 *
 * Always 200 for a well-formed request: an invalid proposed time is an expected UX outcome
 * returned in ``validation_errors`` (the same rules the clock-in/out PATCH enforces), not an HTTP
 * error. Only a malformed body (e.g. non-ISO datetime) 400s, via the request serializer.
 */
export const timesheetsPayStatusCheckCreate = async (id: string,
    payStatusCheckRequestRequest?: PayStatusCheckRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<PayStatusCheckResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<PayStatusCheckResponse>(getTimesheetsPayStatusCheckCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(payStatusCheckRequestRequest)
  }
);}





export const getTimesheetsPayStatusCheckCreateMutationKey = () => ['timesheetsPayStatusCheckCreate'] as const;

export const getTimesheetsPayStatusCheckCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsPayStatusCheckCreate>>, TError,TimesheetsPayStatusCheckCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsPayStatusCheckCreate>>, TError,TimesheetsPayStatusCheckCreateMutationVariables, TContext> => {

const mutationKey = getTimesheetsPayStatusCheckCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsPayStatusCheckCreate>>, TimesheetsPayStatusCheckCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  timesheetsPayStatusCheckCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsPayStatusCheckCreateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsPayStatusCheckCreate>>>
    export type TimesheetsPayStatusCheckCreateMutationBody = PayStatusCheckRequestRequest | undefined
    export type TimesheetsPayStatusCheckCreateMutationError = void
    export type TimesheetsPayStatusCheckCreateMutationVariables = {id: string;data?: PayStatusCheckRequestRequest}

    export const useTimesheetsPayStatusCheckCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsPayStatusCheckCreate>>, TError,TimesheetsPayStatusCheckCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsPayStatusCheckCreate>>,
        TError,
        TimesheetsPayStatusCheckCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsPayStatusCheckCreateMutationOptions(options), queryClient);
    }
    export const getTimesheetsRetrieveShiftBreaksUrl = (id: string,) => {




  return `/api/timesheets/${id}/shift-breaks/`
}

/**
 * List all shift-breaks for a timesheet
 */
export const timesheetsRetrieveShiftBreaks = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakBase[]> => {

  return customFetch<ShiftBreakBase[]>(getTimesheetsRetrieveShiftBreaksUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimesheetsRetrieveShiftBreaksQueryKey = (id: string,) => {
    return [
    `/api/timesheets/${id}/shift-breaks/`
    ] as const;
    }


export const getTimesheetsRetrieveShiftBreaksQueryOptions = <TData = Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimesheetsRetrieveShiftBreaksQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>> = ({ signal }) => timesheetsRetrieveShiftBreaks(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimesheetsRetrieveShiftBreaksQueryResult = NonNullable<Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>>
export type TimesheetsRetrieveShiftBreaksQueryError = void


export function useTimesheetsRetrieveShiftBreaks<TData = Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>,
          TError,
          Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsRetrieveShiftBreaks<TData = Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>,
          TError,
          Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsRetrieveShiftBreaks<TData = Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimesheetsRetrieveShiftBreaks<TData = Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsRetrieveShiftBreaks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimesheetsRetrieveShiftBreaksQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimesheetsBreakClaimsCreateUrl = () => {




  return `/api/timesheets/break-claims/`
}

/**
 * Record the business's account of a pro's breaks for one shift. Replaces the business's entire claim set, so send every break — a single row on a two-break shift drops the other.
 */
export const timesheetsBreakClaimsCreate = async (shiftBreakClaimWriteRequest: ShiftBreakClaimWriteRequest, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakClaimRead[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ShiftBreakClaimRead[]>(getTimesheetsBreakClaimsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(shiftBreakClaimWriteRequest)
  }
);}





export const getTimesheetsBreakClaimsCreateMutationKey = () => ['timesheetsBreakClaimsCreate'] as const;

export const getTimesheetsBreakClaimsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsCreate>>, TError,TimesheetsBreakClaimsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsCreate>>, TError,TimesheetsBreakClaimsCreateMutationVariables, TContext> => {

const mutationKey = getTimesheetsBreakClaimsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsBreakClaimsCreate>>, TimesheetsBreakClaimsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  timesheetsBreakClaimsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsBreakClaimsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsBreakClaimsCreate>>>
    export type TimesheetsBreakClaimsCreateMutationBody = ShiftBreakClaimWriteRequest
    export type TimesheetsBreakClaimsCreateMutationError = void
    export type TimesheetsBreakClaimsCreateMutationVariables = {data: ShiftBreakClaimWriteRequest}

    export const useTimesheetsBreakClaimsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsCreate>>, TError,TimesheetsBreakClaimsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsBreakClaimsCreate>>,
        TError,
        TimesheetsBreakClaimsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsBreakClaimsCreateMutationOptions(options), queryClient);
    }
    export const getTimesheetsBreakClaimsListUrl = (applicationId: number,) => {




  return `/api/timesheets/break-claims/${applicationId}/`
}

/**
 * Every break claim on a shift, for admins and the shift's managers.
 */
export const timesheetsBreakClaimsList = async (applicationId: number, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakClaimRead[]> => {

  return customFetch<ShiftBreakClaimRead[]>(getTimesheetsBreakClaimsListUrl(applicationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimesheetsBreakClaimsListQueryKey = (applicationId: number,) => {
    return [
    `/api/timesheets/break-claims/${applicationId}/`
    ] as const;
    }


export const getTimesheetsBreakClaimsListQueryOptions = <TData = Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError = void>(applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimesheetsBreakClaimsListQueryKey(applicationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timesheetsBreakClaimsList>>> = ({ signal }) => timesheetsBreakClaimsList(applicationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: applicationId !== null && applicationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimesheetsBreakClaimsListQueryResult = NonNullable<Awaited<ReturnType<typeof timesheetsBreakClaimsList>>>
export type TimesheetsBreakClaimsListQueryError = void


export function useTimesheetsBreakClaimsList<TData = Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError = void>(
 applicationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsBreakClaimsList>>,
          TError,
          Awaited<ReturnType<typeof timesheetsBreakClaimsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsBreakClaimsList<TData = Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsBreakClaimsList>>,
          TError,
          Awaited<ReturnType<typeof timesheetsBreakClaimsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsBreakClaimsList<TData = Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimesheetsBreakClaimsList<TData = Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimesheetsBreakClaimsListQueryOptions(applicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimesheetsBreakClaimsHistoryListUrl = (applicationId: number,) => {




  return `/api/timesheets/break-claims/${applicationId}/history/`
}

/**
 * Every break claim revision on a shift, newest first. Superseded claims appear as delete (-) revisions, since a replaced tier's rows no longer exist on the live timesheet.
 */
export const timesheetsBreakClaimsHistoryList = async (applicationId: number, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakClaimHistoryRevision[]> => {

  return customFetch<ShiftBreakClaimHistoryRevision[]>(getTimesheetsBreakClaimsHistoryListUrl(applicationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimesheetsBreakClaimsHistoryListQueryKey = (applicationId: number,) => {
    return [
    `/api/timesheets/break-claims/${applicationId}/history/`
    ] as const;
    }


export const getTimesheetsBreakClaimsHistoryListQueryOptions = <TData = Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError = void>(applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimesheetsBreakClaimsHistoryListQueryKey(applicationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>> = ({ signal }) => timesheetsBreakClaimsHistoryList(applicationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: applicationId !== null && applicationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimesheetsBreakClaimsHistoryListQueryResult = NonNullable<Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>>
export type TimesheetsBreakClaimsHistoryListQueryError = void


export function useTimesheetsBreakClaimsHistoryList<TData = Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError = void>(
 applicationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsBreakClaimsHistoryList<TData = Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsBreakClaimsHistoryList<TData = Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimesheetsBreakClaimsHistoryList<TData = Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimesheetsBreakClaimsHistoryListQueryOptions(applicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimesheetsBreakClaimsOverrideCreateUrl = () => {




  return `/api/timesheets/break-claims/override/`
}

/**
 * Admin override of the pro's side, the business's side, or both. Replaces the override set wholesale; both parties' original claims survive and stay readable in history.
 */
export const timesheetsBreakClaimsOverrideCreate = async (shiftBreakClaimOverrideRequest: ShiftBreakClaimOverrideRequest, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakClaimRead[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ShiftBreakClaimRead[]>(getTimesheetsBreakClaimsOverrideCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(shiftBreakClaimOverrideRequest)
  }
);}





export const getTimesheetsBreakClaimsOverrideCreateMutationKey = () => ['timesheetsBreakClaimsOverrideCreate'] as const;

export const getTimesheetsBreakClaimsOverrideCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsOverrideCreate>>, TError,TimesheetsBreakClaimsOverrideCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsOverrideCreate>>, TError,TimesheetsBreakClaimsOverrideCreateMutationVariables, TContext> => {

const mutationKey = getTimesheetsBreakClaimsOverrideCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsBreakClaimsOverrideCreate>>, TimesheetsBreakClaimsOverrideCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  timesheetsBreakClaimsOverrideCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsBreakClaimsOverrideCreateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsBreakClaimsOverrideCreate>>>
    export type TimesheetsBreakClaimsOverrideCreateMutationBody = ShiftBreakClaimOverrideRequest
    export type TimesheetsBreakClaimsOverrideCreateMutationError = void
    export type TimesheetsBreakClaimsOverrideCreateMutationVariables = {data: ShiftBreakClaimOverrideRequest}

    export const useTimesheetsBreakClaimsOverrideCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsBreakClaimsOverrideCreate>>, TError,TimesheetsBreakClaimsOverrideCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsBreakClaimsOverrideCreate>>,
        TError,
        TimesheetsBreakClaimsOverrideCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsBreakClaimsOverrideCreateMutationOptions(options), queryClient);
    }
    export const getTimesheetsClockOutAttestationCreateUrl = () => {




  return `/api/timesheets/clock-out-attestation/`
}

/**
 * The pro's clock-out answers when the venue screen clocks them out from their pass.
 */
export const timesheetsClockOutAttestationCreate = async (clockOutAttestationRequest: ClockOutAttestationRequest, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getTimesheetsClockOutAttestationCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(clockOutAttestationRequest)
  }
);}





export const getTimesheetsClockOutAttestationCreateMutationKey = () => ['timesheetsClockOutAttestationCreate'] as const;

export const getTimesheetsClockOutAttestationCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsClockOutAttestationCreate>>, TError,TimesheetsClockOutAttestationCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsClockOutAttestationCreate>>, TError,TimesheetsClockOutAttestationCreateMutationVariables, TContext> => {

const mutationKey = getTimesheetsClockOutAttestationCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsClockOutAttestationCreate>>, TimesheetsClockOutAttestationCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  timesheetsClockOutAttestationCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsClockOutAttestationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsClockOutAttestationCreate>>>
    export type TimesheetsClockOutAttestationCreateMutationBody = ClockOutAttestationRequest
    export type TimesheetsClockOutAttestationCreateMutationError = void
    export type TimesheetsClockOutAttestationCreateMutationVariables = {data: ClockOutAttestationRequest}

    export const useTimesheetsClockOutAttestationCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsClockOutAttestationCreate>>, TError,TimesheetsClockOutAttestationCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsClockOutAttestationCreate>>,
        TError,
        TimesheetsClockOutAttestationCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsClockOutAttestationCreateMutationOptions(options), queryClient);
    }
    export const getTimesheetsShiftBreaksListUrl = (params?: TimesheetsShiftBreaksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/timesheets/shift-breaks/?${stringifiedParams}` : `/api/timesheets/shift-breaks/`
}

/**
 * Retrieves the list of shifts stored by location.
 */
export const timesheetsShiftBreaksList = async (params?: TimesheetsShiftBreaksListParams, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakWrite[]> => {

  return customFetch<ShiftBreakWrite[]>(getTimesheetsShiftBreaksListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimesheetsShiftBreaksListQueryKey = (params?: TimesheetsShiftBreaksListParams,) => {
    return [
    `/api/timesheets/shift-breaks/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTimesheetsShiftBreaksListQueryOptions = <TData = Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError = void>(params?: TimesheetsShiftBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimesheetsShiftBreaksListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timesheetsShiftBreaksList>>> = ({ signal }) => timesheetsShiftBreaksList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimesheetsShiftBreaksListQueryResult = NonNullable<Awaited<ReturnType<typeof timesheetsShiftBreaksList>>>
export type TimesheetsShiftBreaksListQueryError = void


export function useTimesheetsShiftBreaksList<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError = void>(
 params: undefined |  TimesheetsShiftBreaksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsShiftBreaksList>>,
          TError,
          Awaited<ReturnType<typeof timesheetsShiftBreaksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsShiftBreaksList<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError = void>(
 params?: TimesheetsShiftBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsShiftBreaksList>>,
          TError,
          Awaited<ReturnType<typeof timesheetsShiftBreaksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsShiftBreaksList<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError = void>(
 params?: TimesheetsShiftBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimesheetsShiftBreaksList<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError = void>(
 params?: TimesheetsShiftBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimesheetsShiftBreaksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimesheetsShiftBreaksCreateUrl = (params?: TimesheetsShiftBreaksCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/timesheets/shift-breaks/?${stringifiedParams}` : `/api/timesheets/shift-breaks/`
}

/**
 * A TimesheetBreak represents an amount of time that a pro did not work during a gig.
 */
export const timesheetsShiftBreaksCreate = async (shiftBreakWriteRequest: ShiftBreakWriteRequest,
    params?: TimesheetsShiftBreaksCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakWrite> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ShiftBreakWrite>(getTimesheetsShiftBreaksCreateUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(shiftBreakWriteRequest)
  }
);}





export const getTimesheetsShiftBreaksCreateMutationKey = () => ['timesheetsShiftBreaksCreate'] as const;

export const getTimesheetsShiftBreaksCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksCreate>>, TError,TimesheetsShiftBreaksCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksCreate>>, TError,TimesheetsShiftBreaksCreateMutationVariables, TContext> => {

const mutationKey = getTimesheetsShiftBreaksCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsShiftBreaksCreate>>, TimesheetsShiftBreaksCreateMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  timesheetsShiftBreaksCreate(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsShiftBreaksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsShiftBreaksCreate>>>
    export type TimesheetsShiftBreaksCreateMutationBody = ShiftBreakWriteRequest
    export type TimesheetsShiftBreaksCreateMutationError = void
    export type TimesheetsShiftBreaksCreateMutationVariables = {data: ShiftBreakWriteRequest;params?: TimesheetsShiftBreaksCreateParams}

    export const useTimesheetsShiftBreaksCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksCreate>>, TError,TimesheetsShiftBreaksCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsShiftBreaksCreate>>,
        TError,
        TimesheetsShiftBreaksCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsShiftBreaksCreateMutationOptions(options), queryClient);
    }
    export const getTimesheetsShiftBreaksRetrieveUrl = (id: string,) => {




  return `/api/timesheets/shift-breaks/${id}/`
}

/**
 * A TimesheetBreak represents an amount of time that a pro did not work during a gig.
 */
export const timesheetsShiftBreaksRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakWrite> => {

  return customFetch<ShiftBreakWrite>(getTimesheetsShiftBreaksRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimesheetsShiftBreaksRetrieveQueryKey = (id: string,) => {
    return [
    `/api/timesheets/shift-breaks/${id}/`
    ] as const;
    }


export const getTimesheetsShiftBreaksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimesheetsShiftBreaksRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>> = ({ signal }) => timesheetsShiftBreaksRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimesheetsShiftBreaksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>>
export type TimesheetsShiftBreaksRetrieveQueryError = void


export function useTimesheetsShiftBreaksRetrieve<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsShiftBreaksRetrieve<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsShiftBreaksRetrieve<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimesheetsShiftBreaksRetrieve<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimesheetsShiftBreaksRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimesheetsShiftBreaksPartialUpdateUrl = (id: string,
    params?: TimesheetsShiftBreaksPartialUpdateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/timesheets/shift-breaks/${id}/?${stringifiedParams}` : `/api/timesheets/shift-breaks/${id}/`
}

/**
 * A TimesheetBreak represents an amount of time that a pro did not work during a gig.
 */
export const timesheetsShiftBreaksPartialUpdate = async (id: string,
    patchedShiftBreakWriteRequest?: PatchedShiftBreakWriteRequest,
    params?: TimesheetsShiftBreaksPartialUpdateParams, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakWrite> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ShiftBreakWrite>(getTimesheetsShiftBreaksPartialUpdateUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedShiftBreakWriteRequest)
  }
);}





export const getTimesheetsShiftBreaksPartialUpdateMutationKey = () => ['timesheetsShiftBreaksPartialUpdate'] as const;

export const getTimesheetsShiftBreaksPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksPartialUpdate>>, TError,TimesheetsShiftBreaksPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksPartialUpdate>>, TError,TimesheetsShiftBreaksPartialUpdateMutationVariables, TContext> => {

const mutationKey = getTimesheetsShiftBreaksPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsShiftBreaksPartialUpdate>>, TimesheetsShiftBreaksPartialUpdateMutationVariables> = (props) => {
          const {id,data,params} = props ?? {};

          return  timesheetsShiftBreaksPartialUpdate(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsShiftBreaksPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsShiftBreaksPartialUpdate>>>
    export type TimesheetsShiftBreaksPartialUpdateMutationBody = PatchedShiftBreakWriteRequest | undefined
    export type TimesheetsShiftBreaksPartialUpdateMutationError = void
    export type TimesheetsShiftBreaksPartialUpdateMutationVariables = {id: string;data?: PatchedShiftBreakWriteRequest;params?: TimesheetsShiftBreaksPartialUpdateParams}

    export const useTimesheetsShiftBreaksPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksPartialUpdate>>, TError,TimesheetsShiftBreaksPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsShiftBreaksPartialUpdate>>,
        TError,
        TimesheetsShiftBreaksPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsShiftBreaksPartialUpdateMutationOptions(options), queryClient);
    }
    export const getTimesheetsShiftBreaksDestroyUrl = (id: string,) => {




  return `/api/timesheets/shift-breaks/${id}/`
}

/**
 * A TimesheetBreak represents an amount of time that a pro did not work during a gig.
 */
export const timesheetsShiftBreaksDestroy = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getTimesheetsShiftBreaksDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTimesheetsShiftBreaksDestroyMutationKey = () => ['timesheetsShiftBreaksDestroy'] as const;

export const getTimesheetsShiftBreaksDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksDestroy>>, TError,TimesheetsShiftBreaksDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksDestroy>>, TError,TimesheetsShiftBreaksDestroyMutationVariables, TContext> => {

const mutationKey = getTimesheetsShiftBreaksDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsShiftBreaksDestroy>>, TimesheetsShiftBreaksDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  timesheetsShiftBreaksDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsShiftBreaksDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsShiftBreaksDestroy>>>

    export type TimesheetsShiftBreaksDestroyMutationError = void
    export type TimesheetsShiftBreaksDestroyMutationVariables = {id: string}

    export const useTimesheetsShiftBreaksDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksDestroy>>, TError,TimesheetsShiftBreaksDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsShiftBreaksDestroy>>,
        TError,
        TimesheetsShiftBreaksDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsShiftBreaksDestroyMutationOptions(options), queryClient);
    }
    export const getTimesheetsShiftBreaksComplianceCheckCreateUrl = (id: string,) => {




  return `/api/timesheets/shift-breaks/${id}/compliance-check/`
}

/**
 * Side-effect-free verdict for an uncommitted break edit.
 *
 * Runs the same compliance rules as the PATCH write path (see ShiftBreakService.check_compliance
 * for the one deliberate divergence: an incomplete-interval break previews as SKIPPED, with
 * required_fields pointing at the time punches, to route the pro to resolution). Returns the
 * computed verdict (plus the fields mobile must collect when
 * non-compliant) WITHOUT persisting. Lets mobile route to the correct "why was your break not
 * compliant?" sheet before committing a write, without duplicating labor-law rules client-side.
 * The PATCH gate and the clock-out gate remain the authoritative backstops — this endpoint drives
 * mobile UX/routing only.
 */
export const timesheetsShiftBreaksComplianceCheckCreate = async (id: string,
    shiftBreakComplianceCheckRequestRequest: ShiftBreakComplianceCheckRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakComplianceCheckResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ShiftBreakComplianceCheckResponse>(getTimesheetsShiftBreaksComplianceCheckCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(shiftBreakComplianceCheckRequestRequest)
  }
);}





export const getTimesheetsShiftBreaksComplianceCheckCreateMutationKey = () => ['timesheetsShiftBreaksComplianceCheckCreate'] as const;

export const getTimesheetsShiftBreaksComplianceCheckCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksComplianceCheckCreate>>, TError,TimesheetsShiftBreaksComplianceCheckCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksComplianceCheckCreate>>, TError,TimesheetsShiftBreaksComplianceCheckCreateMutationVariables, TContext> => {

const mutationKey = getTimesheetsShiftBreaksComplianceCheckCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsShiftBreaksComplianceCheckCreate>>, TimesheetsShiftBreaksComplianceCheckCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  timesheetsShiftBreaksComplianceCheckCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsShiftBreaksComplianceCheckCreateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsShiftBreaksComplianceCheckCreate>>>
    export type TimesheetsShiftBreaksComplianceCheckCreateMutationBody = ShiftBreakComplianceCheckRequestRequest
    export type TimesheetsShiftBreaksComplianceCheckCreateMutationError = void
    export type TimesheetsShiftBreaksComplianceCheckCreateMutationVariables = {id: string;data: ShiftBreakComplianceCheckRequestRequest}

    export const useTimesheetsShiftBreaksComplianceCheckCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksComplianceCheckCreate>>, TError,TimesheetsShiftBreaksComplianceCheckCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsShiftBreaksComplianceCheckCreate>>,
        TError,
        TimesheetsShiftBreaksComplianceCheckCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsShiftBreaksComplianceCheckCreateMutationOptions(options), queryClient);
    }
    export const getTimesheetsShiftBreaksHistoryListUrl = (id: string,
    params?: TimesheetsShiftBreaksHistoryListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/timesheets/shift-breaks/${id}/history/?${stringifiedParams}` : `/api/timesheets/shift-breaks/${id}/history/`
}

/**
 * Read-only change-history audit trail for a single shift break.
 *
 * Admin/support-only — a GET is a SAFE method, which get_permissions() already gates behind
 * IsGigproAdminPermission. Returns one record per revision (newest first), each carrying the
 * acting user, the timestamp, and the per-field changes between consecutive snapshots so the
 * admin Edit Breaks dialog can render who changed what and when.
 */
export const timesheetsShiftBreaksHistoryList = async (id: string,
    params?: TimesheetsShiftBreaksHistoryListParams, options?: Parameters<typeof customFetch>[1]): Promise<ShiftBreakHistoryRevision[]> => {

  return customFetch<ShiftBreakHistoryRevision[]>(getTimesheetsShiftBreaksHistoryListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimesheetsShiftBreaksHistoryListQueryKey = (id: string,
    params?: TimesheetsShiftBreaksHistoryListParams,) => {
    return [
    `/api/timesheets/shift-breaks/${id}/history/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTimesheetsShiftBreaksHistoryListQueryOptions = <TData = Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError = void>(id: string,
    params?: TimesheetsShiftBreaksHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimesheetsShiftBreaksHistoryListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>> = ({ signal }) => timesheetsShiftBreaksHistoryList(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimesheetsShiftBreaksHistoryListQueryResult = NonNullable<Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>>
export type TimesheetsShiftBreaksHistoryListQueryError = void


export function useTimesheetsShiftBreaksHistoryList<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError = void>(
 id: string,
    params: undefined |  TimesheetsShiftBreaksHistoryListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>,
          TError,
          Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsShiftBreaksHistoryList<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError = void>(
 id: string,
    params?: TimesheetsShiftBreaksHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>,
          TError,
          Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsShiftBreaksHistoryList<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError = void>(
 id: string,
    params?: TimesheetsShiftBreaksHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimesheetsShiftBreaksHistoryList<TData = Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError = void>(
 id: string,
    params?: TimesheetsShiftBreaksHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsShiftBreaksHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimesheetsShiftBreaksHistoryListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimesheetsSuggestedBreaksListUrl = (params: TimesheetsSuggestedBreaksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/timesheets/suggested-breaks/?${stringifiedParams}` : `/api/timesheets/suggested-breaks/`
}

/**
 * List all suggested breaks given market, start time, and end time.
 */
export const timesheetsSuggestedBreaksList = async (params: TimesheetsSuggestedBreaksListParams, options?: Parameters<typeof customFetch>[1]): Promise<SuggestedBreak[]> => {

  return customFetch<SuggestedBreak[]>(getTimesheetsSuggestedBreaksListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimesheetsSuggestedBreaksListQueryKey = (params?: TimesheetsSuggestedBreaksListParams,) => {
    return [
    `/api/timesheets/suggested-breaks/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTimesheetsSuggestedBreaksListQueryOptions = <TData = Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError = void>(params: TimesheetsSuggestedBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimesheetsSuggestedBreaksListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>> = ({ signal }) => timesheetsSuggestedBreaksList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimesheetsSuggestedBreaksListQueryResult = NonNullable<Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>>
export type TimesheetsSuggestedBreaksListQueryError = void


export function useTimesheetsSuggestedBreaksList<TData = Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError = void>(
 params: TimesheetsSuggestedBreaksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>,
          TError,
          Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsSuggestedBreaksList<TData = Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError = void>(
 params: TimesheetsSuggestedBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>,
          TError,
          Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsSuggestedBreaksList<TData = Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError = void>(
 params: TimesheetsSuggestedBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimesheetsSuggestedBreaksList<TData = Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError = void>(
 params: TimesheetsSuggestedBreaksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsSuggestedBreaksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimesheetsSuggestedBreaksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimesheetsTimePunchesCreateUrl = () => {




  return `/api/timesheets/time-punches/`
}

/**
 * A TimePunch represents a pro's clock in/out event during a gig.
 */
export const timesheetsTimePunchesCreate = async (timePunchCreateRequest: TimePunchCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<TimePunchCreate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TimePunchCreate>(getTimesheetsTimePunchesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(timePunchCreateRequest)
  }
);}





export const getTimesheetsTimePunchesCreateMutationKey = () => ['timesheetsTimePunchesCreate'] as const;

export const getTimesheetsTimePunchesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsTimePunchesCreate>>, TError,TimesheetsTimePunchesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsTimePunchesCreate>>, TError,TimesheetsTimePunchesCreateMutationVariables, TContext> => {

const mutationKey = getTimesheetsTimePunchesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsTimePunchesCreate>>, TimesheetsTimePunchesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  timesheetsTimePunchesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsTimePunchesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsTimePunchesCreate>>>
    export type TimesheetsTimePunchesCreateMutationBody = TimePunchCreateRequest
    export type TimesheetsTimePunchesCreateMutationError = void
    export type TimesheetsTimePunchesCreateMutationVariables = {data: TimePunchCreateRequest}

    export const useTimesheetsTimePunchesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsTimePunchesCreate>>, TError,TimesheetsTimePunchesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsTimePunchesCreate>>,
        TError,
        TimesheetsTimePunchesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsTimePunchesCreateMutationOptions(options), queryClient);
    }
    export const getTimesheetsTimePunchesRetrieveUrl = (id: string,) => {




  return `/api/timesheets/time-punches/${id}/`
}

/**
 * A TimePunch represents a pro's clock in/out event during a gig.
 */
export const timesheetsTimePunchesRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TimePunchRetrieve> => {

  return customFetch<TimePunchRetrieve>(getTimesheetsTimePunchesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimesheetsTimePunchesRetrieveQueryKey = (id: string,) => {
    return [
    `/api/timesheets/time-punches/${id}/`
    ] as const;
    }


export const getTimesheetsTimePunchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimesheetsTimePunchesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>> = ({ signal }) => timesheetsTimePunchesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimesheetsTimePunchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>>
export type TimesheetsTimePunchesRetrieveQueryError = void


export function useTimesheetsTimePunchesRetrieve<TData = Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsTimePunchesRetrieve<TData = Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimesheetsTimePunchesRetrieve<TData = Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimesheetsTimePunchesRetrieve<TData = Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timesheetsTimePunchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimesheetsTimePunchesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimesheetsTimePunchesPartialUpdateUrl = (id: string,) => {




  return `/api/timesheets/time-punches/${id}/`
}

/**
 * A TimePunch represents a pro's clock in/out event during a gig.
 */
export const timesheetsTimePunchesPartialUpdate = async (id: string,
    patchedTimePunchPartialUpdateRequest?: PatchedTimePunchPartialUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<TimePunchPartialUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TimePunchPartialUpdate>(getTimesheetsTimePunchesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedTimePunchPartialUpdateRequest)
  }
);}





export const getTimesheetsTimePunchesPartialUpdateMutationKey = () => ['timesheetsTimePunchesPartialUpdate'] as const;

export const getTimesheetsTimePunchesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsTimePunchesPartialUpdate>>, TError,TimesheetsTimePunchesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsTimePunchesPartialUpdate>>, TError,TimesheetsTimePunchesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getTimesheetsTimePunchesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsTimePunchesPartialUpdate>>, TimesheetsTimePunchesPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  timesheetsTimePunchesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsTimePunchesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsTimePunchesPartialUpdate>>>
    export type TimesheetsTimePunchesPartialUpdateMutationBody = PatchedTimePunchPartialUpdateRequest | undefined
    export type TimesheetsTimePunchesPartialUpdateMutationError = void
    export type TimesheetsTimePunchesPartialUpdateMutationVariables = {id: string;data?: PatchedTimePunchPartialUpdateRequest}

    export const useTimesheetsTimePunchesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsTimePunchesPartialUpdate>>, TError,TimesheetsTimePunchesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsTimePunchesPartialUpdate>>,
        TError,
        TimesheetsTimePunchesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsTimePunchesPartialUpdateMutationOptions(options), queryClient);
    }
    export const getTimesheetsTimePunchesVerifyCreateUrl = (id: string,) => {




  return `/api/timesheets/time-punches/${id}/verify/`
}

/**
 * Verify a time punch flagged for staffer review: confirm its time, update the pro's working hours, clear the flag and notify the pro. Once the pro is paid, only the recorded time can be confirmed.
 */
export const timesheetsTimePunchesVerifyCreate = async (id: string,
    timePunchVerifyRequestRequest: TimePunchVerifyRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<_TimesheetTimePunchInline> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<_TimesheetTimePunchInline>(getTimesheetsTimePunchesVerifyCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(timePunchVerifyRequestRequest)
  }
);}





export const getTimesheetsTimePunchesVerifyCreateMutationKey = () => ['timesheetsTimePunchesVerifyCreate'] as const;

export const getTimesheetsTimePunchesVerifyCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsTimePunchesVerifyCreate>>, TError,TimesheetsTimePunchesVerifyCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timesheetsTimePunchesVerifyCreate>>, TError,TimesheetsTimePunchesVerifyCreateMutationVariables, TContext> => {

const mutationKey = getTimesheetsTimePunchesVerifyCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timesheetsTimePunchesVerifyCreate>>, TimesheetsTimePunchesVerifyCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  timesheetsTimePunchesVerifyCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimesheetsTimePunchesVerifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof timesheetsTimePunchesVerifyCreate>>>
    export type TimesheetsTimePunchesVerifyCreateMutationBody = TimePunchVerifyRequestRequest
    export type TimesheetsTimePunchesVerifyCreateMutationError = void
    export type TimesheetsTimePunchesVerifyCreateMutationVariables = {id: string;data: TimePunchVerifyRequestRequest}

    export const useTimesheetsTimePunchesVerifyCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timesheetsTimePunchesVerifyCreate>>, TError,TimesheetsTimePunchesVerifyCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timesheetsTimePunchesVerifyCreate>>,
        TError,
        TimesheetsTimePunchesVerifyCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTimesheetsTimePunchesVerifyCreateMutationOptions(options), queryClient);
    }
